import React from 'react';
import SessionStore from 'stores/SessionStore';

const NavbarOverlayBanner = ({ text, showButton }) => {
  const containerStyle = {
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    color: 'white',
    background: 'rgb(33, 184, 142)',
    zIndex: 99999,
    position: 'absolute',
    right: '20em',
    top: '0px',
  };

  return (
    <div
      className="p-2 h-8 w-84 flex flex-grow text-white uppercase font-semibold"
      style={containerStyle}
    >
      <div className="mb-2 flex">
        <span className="mr-8">Logged in as {text}</span>
        {showButton && (
          <button
            onClick={() => SessionStore.onLogout()}
            className="mb-2 underline"
          >
            Log out
          </button>
        )}
      </div>
    </div>
  );
};

export default NavbarOverlayBanner;
